import React from "react";
import CauseList from "./CauseList";
import BreadCrumb from "../../Components/BreadCrumb";

const CauseListPage = (benchId) => {
  return (
    <>
      <div className="col-12 col-sm-12 col-md-9 col-lg-9">
        <BreadCrumb title="Cause List" />
        <div className="about-bg inner-page-section">
          <div className="container">
            <div className="row">
              <div className="col-12 col-sm-12 col-md-12 col-lg-12">
                <CauseList benchId={benchId} />
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default CauseListPage;
